import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { useProps } from "./auth-service-tools225.js";
import { factory } from "./auth-service-tools248.js";
import { Input } from "./auth-service-tools299.js";
import { useComboboxContext } from "./auth-service-tools332.js";
import { useComboboxTargetProps } from "./auth-service-tools347.js";
import classes from "./auth-service-tools330.js";
import { useMergedRef } from "./auth-service-tools278.js";
const defaultProps = {
  withAriaAttributes: true,
  withKeyboardNavigation: true
};
const ComboboxSearch = factory((_props, ref) => {
  const props = useProps("ComboboxSearch", defaultProps, _props);
  const {
    classNames,
    styles,
    unstyled,
    vars,
    withAriaAttributes,
    onKeyDown,
    withKeyboardNavigation,
    size,
    ...others
  } = props;
  const ctx = useComboboxContext();

  const _styles = ctx.getStyles("search");

  const targetProps = useComboboxTargetProps({
    targetType: "input",
    withAriaAttributes,
    withKeyboardNavigation,
    withExpandedAttribute: false,
    onKeyDown,
    autoComplete: "off"
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(Input, {
    ref: useMergedRef(ref, ctx.store.searchRef),
    classNames: [{
      input: _styles.className
    }, classNames],
    styles: [{
      input: _styles.style
    }, styles],
    size: size || ctx.size,
    ...targetProps,
    ...others,
    __staticSelector: "Combobox"
  });
});
ComboboxSearch.classes = classes;
ComboboxSearch.displayName = "@mantine/core/ComboboxSearch";
export { ComboboxSearch };